const state = {
  document: {
    id: null,
    name: null
  },
  documents: [],
  dataToPersist: null
}

const getters = {
  documentsCreated (state) {
    return state.documents.length ? state.documents : null
  },
  lastDocumentCreated (state) {
    return state.document.id ? state.document : null
  },
  dataToPersist (state) {
    return state.dataToPersist
  }
}

const mutations = {
  setDocument (state, payload) {
    state.document = payload
    state.documents.push(payload)
  },
  setDataToPersist (state, payload) {
    state.dataToPersist = payload
  },
  clearProcessesStore (state) {
    state.document.id = null
    state.document.name = null
    state.documents = []
    state.dataToPersist = null
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
